export default "__VITE_ASSET__BOVG$jDL__"